import { challengesForm } from '../../modules/challengesForm';

export const challengesEdit = () => {
  challengesForm();
};
